  
function loadPpta(view) {
    return () => import( /* webpackChunkName: "ppta-[request]" */ `../components/Ppta/${view}.vue`)
}
const route = [
    {
        path: '/ppta/main-view',
        name: 'Ppta-MainView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadPpta('MainView')
    },
    {
        path: '/ppta-rubric',
        name: 'PptaRubricCategory',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadPpta('RubricCategory')
    },
    {
        path: '/ppta-rubric/:categoryId',
        name: 'PptaRubricField',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadPpta('RubricField')
    },
]

export default route